'use strict';

module.exports = {
    LANG: 'en-us',
    SIGN: 'Sign In',
    REGISTER: 'REGISTER',
    QUICK_ACCESS: 'Quick access with',
    SIGN_JOIN: 'Sign In or Join for Free!',
    NOT_MEMBER: 'Not a Member?',
    ALREADY_MEMBER: 'Already an AliExpress/Alibaba Member?',
    SHOW_ALL: 'Show all',
    HIDE: 'Hide'
};